import {securityProfileHasLoadedAction, userSubmittedSecurityConfigAction} from "../actions";

export const postUserSecurityProfile = (securityConfiguration) => {
    return (dispatch, getState) => {
        let message = "User submitted security configuration: [ "+JSON.stringify(securityConfiguration)+" ]. ";
        const { csrfToken } = getState();
        let url = '/api/security-profile';

        fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(securityConfiguration),
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json'
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                message = message + ". Response: "+JSON.stringify(resp);
                console.info(message);
            })
            .catch(err => {
                message = message + ". Security submission resulted in error: [ " + JSON.stringify(err) + "]. ";
                console.error(err);
            })
            .finally(
                dispatch(userSubmittedSecurityConfigAction(securityConfiguration))
            )

    }
};

export const fetchUserSecurityConfiguration = () => {
    return (dispatch, getState) => {
        const { user, csrfToken } = getState();

        if (user !== null && user !== undefined && "email" in user) {
            let url = "/api/security-profile";
            fetch (url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-XSRF-TOKEN': csrfToken,
                    'Accept': 'application/json'
                }
            }).then(resp => resp.json())
                .then(resp => {
                    dispatch(securityProfileHasLoadedAction(resp));
                })
        }
    }
};
